import React from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { fetchFeed } from '../../../../actions/feed';
import Listing, { MobileListing } from './Listing';
import { isMobile } from '../../../../lib/getDeviceSize';
import styles from '../../../../styles/sass/components/RecommendedListings.module.scss';
import LogoLoader from '../../../utility/LogoLoader';
import * as types from '../../../../actions/actionTypes';

interface Props {
  dispatch: any;
  feedSearch: any;
  recommendedListings: any;
  recommendsLoading: boolean;
  token: any;
  signupSurveyDetails: any;
  firstSearchCompleted: boolean;
}

export class RecommendedListings extends React.Component<Props> {
  componentDidMount() {
    const {
      recommendedListings,
      recommendsLoading,
      signupSurveyDetails,
      firstSearchCompleted,
    } = this.props;
    if (recommendedListings.length !== 0 && recommendsLoading) return;

    // Use current location will only be used if signup survey details are not filled and user has not performed first search
    if (
      !signupSurveyDetails.state &&
      !signupSurveyDetails.city &&
      !firstSearchCompleted
    ) {
      this.fetchRecommendationsFromCurrentLocation();
    } else {
      this.fetchRecommendations(0, true);
    }
  }

  fetchRecommendationsFromCurrentLocation = async () => {
    this.props.dispatch({
      recommendsLoading: true,
      type: types.FetchingRecommendedListings,
    });
    try {
      const position: any = await this.getPosition();
      // Try to get listings from current location
      const filters = {
        location: `${position.coords.latitude},${position.coords.longitude}`,
        boundingBox: undefined,
        locationName: undefined,
      };
      this.fetchRecommendations(0, true, filters, true);
    } catch (error) {
      // If location access is denied or some error occurs, fetch from default location
      this.fetchRecommendations(0, true);
    }
  };

  getPosition = () => {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject),
    );
  };

  fetchRecommendations = (
    offset: number = 0,
    refresh = false,
    extraValues = {},
    sendCallback?: boolean,
  ) => {
    const { dispatch, feedSearch, token } = this.props;
    dispatch(
      fetchFeed(
        { ...feedSearch, ...extraValues },
        token,
        10,
        offset,
        refresh,
        true,
        sendCallback ? () => this.fetchRecommendations(0, true) : undefined,
      ),
    );
  };

  fetchMore = () => {
    this.fetchRecommendations(this.props.recommendedListings.length);
  };

  renderCarousel = () => {
    const { recommendedListings } = this.props;
    return (
      <div>
        <Carousel
          afterSlide={(index: number) => {
            if (recommendedListings.length - index === 3) {
              this.fetchMore();
            }
          }}
          animation="zoom"
          autoplay={false}
          cellAlign="center"
          heightMode="max"
          slideIndex={0}
          slidesToShow={1}
          slidesToScroll={1}
          height="300px"
          withoutControls
          className={styles.listingsMobile}
        >
          {recommendedListings.map((listing: any, index: number) => {
            return <MobileListing listing={listing} key={index} />;
          })}
        </Carousel>
      </div>
    );
  };

  renderListings = () => {
    return isMobile() ? (
      <React.Fragment>{this.renderCarousel()}</React.Fragment>
    ) : (
      <React.Fragment>
        <div className={styles.listings}>
          {this.props.recommendedListings.map((listing: any, index: any) => {
            return <Listing listing={listing} key={index} />;
          })}
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { recommendedListings, recommendsLoading } = this.props;

    const disabled = recommendsLoading || recommendedListings.length === 0;
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headingText}>
            {isMobile()
              ? `Recommended For You`
              : `Check out these recommended listings`}
          </div>
        </div>
        {recommendsLoading ? (
          <LogoLoader imageProps={{ style: { height: 150, width: 150 } }} />
        ) : recommendedListings.length === 0 ? (
          <div>
            <span style={{ fontSize: 18 }}>
              Feels a bit empty here. Try another search or adjusting your
              preferences for more listing recommendations.
            </span>
          </div>
        ) : (
          this.renderListings()
        )}
        {!isMobile() && (
          <Button
            disabled={disabled}
            className={
              disabled ? styles.viewMoreButtonDisabled : styles.viewMoreButton
            }
            onClick={this.fetchMore}
            style={{ marginTop: 20 }}
          >
            View More
          </Button>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  feedSearch: state.feed.feedSearch,
  recommendedListings: state.dashboard.recommendedListings || [],
  recommendsLoading: state.dashboard.recommendsLoading,
  token: state.auth.token,
  signupSurveyDetails: state.signupSurvey.signupSurveyDetails,
  firstSearchCompleted: state.dashboard.firstSearchCompleted,
});

export default connect(mapStateToProps)(RecommendedListings);
